<div mat-dialog-title>
  <h1>{{data.title}}</h1>
</div>
<div [formGroup]="formGroup" mat-dialog-content>
  <mat-form-field>
    <input matInput name="value" formControlName="value" [placeholder]="data.placeholder" required>
  </mat-form-field>
</div>
<div mat-dialog-actions style="display: flex; flex-direction: row; gap: 30px; margin-top: 10px; justify-content: center; align-items: center">
  <button mat-raised-button (click)="onSave();">Save</button>
  <button mat-raised-button (click)="onClose();">Cancel</button>
</div>
